<div class="db-fc-search-input" [ngClass]="{'not-empty': value, 'big-size': bigSize, 'db-fc-search-input__gray-style': grayStyle}">
  <input type="text" [(value)]="value" (input)="onChange.next($event)" (keydown)="onKeydown($event)" placeholder="{{placeholder}}" autocomplete="off">
  <i class="db-icon db-icon-close" (click)="clearValue()"></i>
  <div class="placeholder-title">
    <i class="db-icon db-icon-search"></i>
    <span>{{placeholderTitle}}</span>
  </div>
</div>
